import { tw } from '@/utils/tw';

const TextTitle = tw.theme({
  base: 'text-headline-md md:text-headline-lg mb-2.5 mt-1.25',
});

export default TextTitle;
